/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AbpPtwExceptionHttpResponseModel,
  AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetails,
  RunMeasurementRequestDto,
  RunningMeasurementResponseDto,
} from '../models/index';
import {
    AbpPtwExceptionHttpResponseModelFromJSON,
    AbpPtwExceptionHttpResponseModelToJSON,
    AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsFromJSON,
    AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsToJSON,
    RunMeasurementRequestDtoFromJSON,
    RunMeasurementRequestDtoToJSON,
    RunningMeasurementResponseDtoFromJSON,
    RunningMeasurementResponseDtoToJSON,
} from '../models/index';

export interface RunMeasurementRequest {
    runMeasurementRequestDto?: RunMeasurementRequestDto;
}

export interface StopMeasurementRequest {
    measurementId: string;
}

/**
 * 
 */
export class MeasurementsApi extends runtime.BaseAPI {

    /**
     */
    async runMeasurementRaw(requestParameters: RunMeasurementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RunningMeasurementResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/work-steps/run-measurement`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RunMeasurementRequestDtoToJSON(requestParameters.runMeasurementRequestDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => RunningMeasurementResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async runMeasurement(requestParameters: RunMeasurementRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.runMeasurementRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<RunningMeasurementResponseDto>(response, errorHandlers);
    }

    /**
     */
    async stopMeasurementRaw(requestParameters: StopMeasurementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.measurementId === null || requestParameters.measurementId === undefined) {
            throw new runtime.RequiredError('measurementId','Required parameter requestParameters.measurementId was null or undefined when calling stopMeasurement.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/work-steps/{measurementId}/cancel`.replace(`{${"measurementId"}}`, encodeURIComponent(String(requestParameters.measurementId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async stopMeasurement(requestParameters: StopMeasurementRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.stopMeasurementRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

}
